// extracted by mini-css-extract-plugin
module.exports = {"container":"SubBrandLogos_container__m3vBb","logo":"SubBrandLogos_logo__sNIHZ"};